(function(algolia) {
  'use strict';
  var translations = algolia.translations;
  algoliaShopify.shopify = algoliaShopify.shopify || algolia.shopify || window.algoliasearch?.shopify;
  var sort_order_base;
  if (algolia.helpers && algolia.helpers.productsIndexName && algoliaShopify.shopify && algoliaShopify.shopify.market) {
    var sort_locale = algoliaShopify.shopify.market.language.shop_locale.locale;
    var sort_market_id = algolia.helpers.normalizeMarketId(algoliaShopify.shopify.market.id);
    var sort_market_key = sort_market_id + '_' + sort_locale;
    sort_order_base = algolia.helpers.productsIndexName(sort_market_key, sort_locale);
  } else {
    var index_suffix = algoliaShopify.config.index_suffix;
    sort_order_base = algoliaShopify.config.index_prefix + 'products';
    if (index_suffix) {
      sort_order_base += index_suffix;
    }
  }  
  
  var relevantSortOrderLabel = translations?.sort_orders?.find(sortOrder => sortOrder.key === 'relevant');
  algolia.sortOrders = [
    { value: sort_order_base, label: '' + `${relevantSortOrderLabel ? relevantSortOrderLabel.title : algolia.translations.relevance}` },
  ];

  algoliaShopify.config.sort_orders.forEach(function(sort_order) {
    if (
      sort_order.asc &&
      (sort_order.asc.active === true || sort_order.asc.active === '1')
      ) {
      const translatedSortOrder = translations?.sort_orders?.find(sortOrder => `${sortOrder.key}` === `${sort_order.key}_asc`);
      algolia.sortOrders.push({
        value: sort_order_base + '_' + sort_order.key + '_asc',
        label: translatedSortOrder ? translatedSortOrder.title : sort_order.asc.title,
      });
    }

    if (
      sort_order.desc &&
      (sort_order.desc.active === true || sort_order.desc.active === '1')
    ) {
      const translatedSortOrder = translations?.sort_orders?.find(sortOrder => `${sortOrder.key}` === `${sort_order.key}_desc`);
      algolia.sortOrders.push({
        value: sort_order_base + '_' + sort_order.key + '_desc',
        label: translatedSortOrder ? translatedSortOrder.title : sort_order.desc.title,
      });
    }
  });

  // try to fetch sort orders for current collection or fallback to collections default
  var collection_sort_orders =
    algolia.current_collection_id &&
    algoliaShopify.config.collection_sort_orders &&
    algoliaShopify.config.collection_sort_orders[algolia.current_collection_id]
      ? algoliaShopify.config.collection_sort_orders[algolia.current_collection_id]
      : algoliaShopify.config.collection_sort_orders &&
        algoliaShopify.config.collection_sort_orders.default;

  if (collection_sort_orders) {
    algolia.collectionSortOrders = [
      { value: sort_order_base, label: '' + algolia.translations.relevance },
    ];

    collection_sort_orders.forEach(function(sort_order) {
      if (
        sort_order.asc &&
        (sort_order.asc.active === true || sort_order.asc.active === '1')
      ) {
        algolia.collectionSortOrders.push({
          value: sort_order_base + '_' + sort_order.key + '_asc',
          label: sort_order.asc.title,
        });
      }

      if (
        sort_order.desc &&
        (sort_order.desc.active === true || sort_order.desc.active === '1')
      ) {
        algolia.collectionSortOrders.push({
          value: sort_order_base + '_' + sort_order.key + '_desc',
          label: sort_order.desc.title,
        });
      }
    });
  }
})(window.algoliasearch);
